import { Paper } from '@mui/material';
import styled, { css } from 'styled-components';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';

interface TooltipProps {
  descriptor: string;
  onDismiss: () => void;
  placement: 'top' | 'bottom' | 'left' | 'right';
  text: string | Array<string>;
}

const placementsStyles = {
  top: {
    top: '6em',
    left: '50%',
    transform: 'translateX(-50%)'
  },
  bottom: {
    bottom: '2em',
    left: '50%',
    transform: 'translateX(-50%)'
  },
  left: {
    left: '2em',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  right: {
    right: '2em',
    top: '50%',
    transform: 'translateY(-50%)'
  }
};

export const Tooltip: React.FC<TooltipProps> = (props: TooltipProps) => {
  return (
    <Layout $placement={props.placement}>
      <Paper
        sx={{ padding: '0.4em 1.8em 0.4em 0.5em', width: 'fit-content', position: 'relative' }}
        data-testid={`${props.descriptor}-tooltip`}
      >
        <CenteredDiv>{Array.isArray(props.text) ? <Texts texts={props.text} /> : props.text}</CenteredDiv>
        <DismissButton onClick={props.onDismiss}>
          <CancelIcon />
        </DismissButton>
      </Paper>
    </Layout>
  );
};

const Layout = styled.div<{ $placement: TooltipProps['placement'] }>`
  display: flex;
  justify-content: center;
  position: absolute;
  width: 75%;
  ${({ $placement }): ReturnType<typeof css> => css(placementsStyles[$placement])}
`;

const CenteredDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8em;
`;

const Texts: React.FC<{ texts: Array<string> }> = ({ texts }) => texts.map((text, i) => <div key={i}>{text}</div>);

const DismissButton = styled(IconButton)`
  position: absolute;
  right: 0.3em;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.1em;
  pointer-events: auto;
  cursor: pointer;
  color: #9d9d9d;
  font-size: 0.5em;
  border: 0;
  background-color: transparent;
  &:hover {
    color: #000;
  }
  & svg {
    font-size: 2.5em;
  }
`;
